import { html } from 'lit';
import { sectionHeading } from '../components/sectionHeading.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

type FaqSectionKey = 'faqApplicant' | 'faqCompany';

export const faqSection = (section: FaqSectionKey, content: LandingContent, editor?: LandingEditorRenderOptions, options: { headingTag?: 'h1' | 'h2'; style?: string } = {}) => {
  const data = content[section];

  return html`
    <section
      class=${editorNodeClass(editor, `section.${section}`, 'vp-section vp-faq-section')}
      style=${options.style ?? editorNodeStyle(editor, `section.${section}`)}
      @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `section.${section}`, event)}
      @click=${(event: MouseEvent) => editorNodeClick(editor, `section.${section}`, event)}
    >
      <div class="vp-shell vp-faq-shell">
        ${sectionHeading({
          headingTag: options.headingTag,
          eyebrow: data.eyebrow,
          title: data.title,
          highlight: data.titleHighlight,
          text: data.text,
          align: 'center',
          editor,
          elementPrefix: section,
        })}

        <div
          class=${editorNodeClass(editor, `${section}.items`, 'vp-faq-list')}
          style=${editorNodeStyle(editor, `${section}.items`)}
          @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `${section}.items`, event)}
          @click=${(event: MouseEvent) => editorNodeClick(editor, `${section}.items`, event)}
        >
          ${data.items.map(
            (item, index) => html`
              <details
                class=${editorNodeClass(editor, `${section}.item.${index}`, 'vp-faq-item reveal-card')}
                style=${editorNodeStyle(editor, `${section}.item.${index}`)}
                @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `${section}.item.${index}`, event)}
              >
                <summary class="vp-faq-question">
                  <span
                    class=${editorNodeClass(editor, `${section}.item.${index}.question`)}
                    style=${editorNodeStyle(editor, `${section}.item.${index}.question`)}
                    @click=${(event: MouseEvent) => editorNodeClick(editor, `${section}.item.${index}.question`, event)}
                    >${item.question}</span
                  >
                  <span class="icon-[material-symbols--add-rounded] vp-faq-toggle" aria-hidden="true"></span>
                </summary>
                <p
                  class=${editorNodeClass(editor, `${section}.item.${index}.answer`, 'vp-faq-answer')}
                  style=${editorNodeStyle(editor, `${section}.item.${index}.answer`)}
                  @click=${(event: MouseEvent) => editorNodeClick(editor, `${section}.item.${index}.answer`, event)}
                >
                  ${item.answer}
                </p>
              </details>
            `,
          )}
        </div>
      </div>
    </section>
  `;
};
